import React from "react";
import { noop } from "@common/helpers/function";
import {
    FilterMultiselect,
    FilterMultiselectOption,
} from "@components/pageHeader/filters/FilterMultiselect/FilterMultiselect";
import { BaseFilterProps } from "../../lib";
import styles from "../ApplicationTypeFilter/ApplicationTypeFilter.module.scss";

const HAS_UNREAD = "true";
const NO_UNREAD = "false";

const unreadValues: ReadonlySet<string> = new Set([HAS_UNREAD, NO_UNREAD]);

const unreadFilterOptionLabels = {
    [HAS_UNREAD]: "Has unread",
    [NO_UNREAD]: "No unread",
} as const;

const options: FilterMultiselectOption[] = [
    {
        value: HAS_UNREAD,
        label: unreadFilterOptionLabels[HAS_UNREAD],
        searchableLabel: unreadFilterOptionLabels[HAS_UNREAD],
    },
    {
        value: NO_UNREAD,
        label: unreadFilterOptionLabels[NO_UNREAD],
        searchableLabel: unreadFilterOptionLabels[NO_UNREAD],
    },
];

function selectedUnreadValues(hasUnread: boolean | undefined): string[] {
    if (hasUnread === undefined) {
        return [];
    }
    return [String(hasUnread)];
}

function hasUnreadFromSelection(selected: string[]): boolean | undefined {
    const isHasUnreadSelected = selected.includes(HAS_UNREAD);
    const isNoUnreadSelected = selected.includes(NO_UNREAD);
    if (isHasUnreadSelected === isNoUnreadSelected) {
        return undefined;
    }
    return isHasUnreadSelected;
}

export const UnreadFilter: React.FC<BaseFilterProps> = ({
    filters,
    onChange,
}) => {
    const value = selectedUnreadValues(filters.hasUnread);

    return (
        <div className={styles.filter}>
            <FilterMultiselect
                inDropdown={false}
                searchable={false}
                options={options}
                value={value}
                onChange={(val) => {
                    const selected = val
                        .map(String)
                        .filter((item) => unreadValues.has(item));
                    onChange({
                        hasUnread: hasUnreadFromSelection(selected),
                    });
                }}
                name="hasUnread"
                onBlur={noop}
            />
        </div>
    );
};
